export enum SuspendedJobTypes {
    Dummy = 'Dummy',
    FormGoto = 'FormGoto',
    JumpLine = 'JumpLine',
    FormHtml = 'FormHtml',
    SubForm = 'SubForm',
    FormBrother = 'FormBrother',
    SelectAll = 'SelectAll',
    SendKey = 'SendKey',
    ReplaceText = 'ReplaceText',
    FormExit = 'FormExit',
    ZoomFormExit = 'ZoomFormExit',
    SelectItem = 'SelectItem',
    Find = 'Find',
    GotoLine = 'GotoLine',
    SaveVal = 'SaveVal',
    RestoreVal = 'RestoreVal',
    RetrieveRecords = 'RetrieveRecords',
    StoreRecords = 'StoreRecords',
    DelRecord = 'DelRecord',
    ClickCheckBox = 'ClickCheckBox',
    Zoom = 'Zoom',
    MessageAnswer = 'MessageAnswer',
    Resize = 'Resize',
    GetServerFile = 'GetServerFile',
    PasteColumn = 'PasteColumn',
    Input = 'Input',
    SetCover = 'SetCover',
    SetPaintedAttachment = 'SetPaintedAttachment',
    ReactServerCall = 'ReactServerCall',
    SortCol = 'SortCol',
    StartEntity = 'StartEntity',
    ChangeEntity = 'ChangeEntity',
    Command = 'Command',
    FieldValue = 'FieldValue',
    //
    Keydown = 'keydown',
    Keypress = 'keypress',
    Click = 'click'
}
